import { combineReducers } from 'redux';

import endReached from './endReached/reducer';
import list from './list/reducer';

export default combineReducers({
  endReached,
  list
});



/** WEBPACK FOOTER **
 ** ./src/members/state/comments/live/reducer.js
 **/